import { FilterSetName } from 'store/modules/routerUtils/types';

type FilterKey = string;
type FilterValue = string[];
type FilterSet = Record<FilterKey, FilterValue>;

export function getFilterSetFromSearchParams(
  searchParams: URLSearchParams,
  filterSetName: FilterSetName
): FilterSet {
  const result: FilterSet = {};
  const prefix = `filter.${filterSetName}.`;

  for (const key of searchParams.keys()) {
    if (key.startsWith(prefix)) {
      let paramName = key.slice(prefix.length);
      // Match query-string arrayFormat: 'bracket' – parsed keys are without '[]'
      if (paramName.endsWith('[]')) {
        paramName = paramName.slice(0, -2);
      }
      const values = searchParams.getAll(key).filter(Boolean);
      if (values.length) {
        result[paramName] = values;
      }
    }
  }

  return result;
}
